import { VdpGallery } from '../components/vdp/gallery.vue';
Vue.component('vdp-gallery', VdpGallery);